import React from 'react';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';

class LoadingView extends React.PureComponent {
    render() {
        return (
            <LoadingWrapperView
                loading={!this.props.children}
                >
                {this.props.children}
            </LoadingWrapperView>
        );
    }
}

export default LoadingView;
